var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "about" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c("img", { staticClass: "about-image", attrs: { src: _vm.about } })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n          O que "),
        _c("span", [_vm._v("fazemos")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _c("p", [
          _vm._v(
            "\n            Conectamos Organizações Sociais, Varejo e Pessoas através de ferramentas de Marketing\n            Relacionado à Causa e geramos valor por meio da ampliação do conceito de doação.\n            Queremos que o ato de doar seja incorporado ao dia a dia das pessoas e naquilo que elas já\n            fazem.\n          "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Ao comprar um produto com desconto em uma empresa afiliada, você estará ajudando uma\n            Organização Social.\n            "
          ),
          _c("ul", [
            _c("li", [
              _vm._v("Para ONGs: arrecadação, divulgação, comunicação")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Para Varejo: aumento de vendas, marketing relacionado à causa, valorização da marca"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Para Pessoas: descontos, facilidade, segurança")])
          ])
        ]),
        _vm._v(" "),
        _c("p", [
          _c("i", [
            _vm._v(
              "“Acreditamos que a tecnologia pode mudar o mundo e ser um agente transformador de vidas.”"
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23eb8a08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23eb8a08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/AboutSection.vue
// module id = null
// module chunks = 